import type { RegistrationProgressResponse } from '@diamond/shared/features/registration/browser';
import { parseRegistrationProgressResponse } from '@diamond/shared/features/registration/browser';
import axios from 'axios';

const API_URL = process.env['NX_API_URL'] || '';

export async function fetchRegistrationProgress(
  registrationToken: string
): Promise<RegistrationProgressResponse> {
  const response = await axios.get<unknown>(`${API_URL}/registration/progress`, {
    headers: {
      Authorization: `Bearer ${registrationToken}`,
    },
  });

  return parseRegistrationProgressResponse(response.data);
}
